const Content03 = () => {
    const data = {
        number: "03.",
        title: "Beyond efficiency, towards business growth",
        subtitle: "Are you ready to unlock new doors of opportunity with Zero Chat?",
        items: [
            {
                title: "Customer Insights",
                description: "By collecting data on customer interactions, Zero Chat helps businesses understand their customers' needs, preferences, and behaviors. This data empowers."
            },
            {
                title: "New Service Models",
                description: "Chatme's capabilities pave the way for innovative customer engagement and service delivery models, fostering new business opportunitie."
            }
        ]
    }

    return (
        <div className="col-span-5 px-4 pt-10 text-[#FFFFFF] md:px-10 lg:col-span-3 lg:pl-20 lg:pr-10 lg:pt-20 xl:pl-36">
            <div className="text-6xl font-semibold bg-gradient-to-b from-white to-[#5AE65E] bg-clip-text text-transparent">{data.number}</div>
            <div className="mt-4 text-4xl font-bold">{data.title}</div>
            <div className="flex items-center justify-start py-4">
                <div className="flex items-center">
                    <div className="h-[1px] w-20 bg-[#5AE65E]"></div>
                    <div className="w-1 h-1 bg-[#5AE65E]" style={{ clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' }}></div>
                </div>
            </div>
            <div className="mb-8 text-base font-normal text-[#BEBEBE]">{data.subtitle}</div>
            <div className="mb-4 text-base gap-5 xl:text-xs 2xl:text-sm">
                {data.items.map((item, index) => (
                    <div key={index} className="flex items-start mb-6 gap-2">
                        <img src="/media/images/icon/checked.png" alt="checked" className="w-5 h-5"/>
                        <div>
                            <div className="font-medium"><span className="font-bold">{item.title}:</span> {item.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Content03;